import apiClient from './apiClient';

export const fahrzeugApi = {
  getAll: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.status) query.set('status', params.status);
    const qs = query.toString();
    const response = await apiClient.get(`/fahrzeuge${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/fahrzeuge', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/fahrzeuge/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/fahrzeuge/${id}`);
    return response.data;
  }
};

export default fahrzeugApi;
